<template>
  <div>
    <div class="breadCrumb breadNav">
      <breadcrumb :breadcrumb_link="regBreadcrumb" />
    </div>
    <div class="header">
      <h1 class="overlay">RESERVATION</h1>
      <div class="headerimage" />
    </div>
    <div class="content">
      <ReserveStage1
        v-if="stage === 1"
        :useRouteParams="useRouteParams"
        :ReserveData="ReserveData"
        @nextStage="nextStage"
      />
      <ReserveStage2 v-if="stage === 2" :ReserveData="ReserveData" @nextStage="nextStage" @prevStage="prevStage" />
      <ReserveStage3 v-if="stage === 3" :reserv-no="reservNoInfo" />
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import ReserveStage1 from '@/pages/PleisureReservePage/Components/ReserveStage1';
import ReserveStage2 from '@/pages/PleisureReservePage/Components/ReserveStage2';
import ReserveStage3 from '@/pages/PleisureReservePage/Components/ReserveStage3';
import reserveService from '@/pages/PleisureReservePage/API/reserve.service';
import {hotelService} from '@/services/hotel.service';
import moment from 'moment';
import {PMSResDto} from '@/models';
import AXIOS from '@/services/axios-wrapper';
import {PMS_YYYYMMDD} from '@/models-hotel';
import {Stage1ViewModel} from '@/pages/PleisureReservePage/Model/reserve.model';
import GeneralUtil from '@/util/GeneralUtil';

export default {
  name: 'ReservePage',
  components: {
    Breadcrumb,
    ReserveStage1,
    ReserveStage2,
    ReserveStage3,
  },
  mixins: [GeneralUtil],
  computed: {
    isLogin() {
      return this.$store.getters['Auth/isLoggedIn'];
    },
    isGuestLogin() {
      return this.$store.getters['Auth/isGuestLoggedIn'];
    },
  },
  data() {
    return {
      stage: 1,
      stage1Vm: null,
      stage2Vm: null,
      regBreadcrumb: {
        toplink: 'HOME',
        prevlink: 'RESERVATION',
        present: '프로그램 예약',
      },
      selectedPkg: null,
      selectedRoom: null,
      amountList: [],
      userBlockTimer: 0,
      reservNoInfo: '', //예약 완료번호
      useRouteParams: true,
      ReserveData: {
        programCode: '',
        mOptionCode: '',
        sOptionCode: '',
        bookName: '',
        bookHpNo: '',
        email: '',
        personCnt: 0,
        reqDate: new Date(),
        reqTime: '',
        reqMemo: '',
      },
    };
  },

  async mounted() {
    this.$store.dispatch('Display/changeName', {name: '프로그램 예약'});
  },

  showErrDialog(msg) {
    this.$bvModal.msgBoxOk(msg, {
      centered: true,
      okTitle: '확인',
      okVariant: 'primary',
    });
  },

  methods: {
    async nextStage(param) {
      if (this.stage === 2) {
        this.reservNoInfo = param;
      }
      this.stage++;
    },
    async prevStage() {
      // 예약2스텝까지 갔다가 돌아오면 라우터 파라메터를 쓰지 않는다.
      //this.useRouteParams = false;
      this.stage--;
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}

.headerimage {
  width: 100%;
  margin: 0;
  content: url('~@/assets/images/common/reservation_headerimage.jpg');
}

@media (max-width: 992px) {
  .header {
    display: none;
  }
  .breadNav {
    display: none;
  }
  .content {
    padding-top: 5rem;
    margin: 0;
  }
}
</style>
